import React from 'react';
import Icon from './Icon';

const SaveIcon = (props) => (
  <Icon {...props}>
    <path d="M15 20V15H9V20M18 20H6C4.89543 20 4 19.1046 4 18V6C4 4.89543 4.89543 4 6 4H14.1716C14.702 4 15.2107 4.21071 15.5858 4.58579L19.4142 8.41421C19.7893 8.78929 20 9.29799 20 9.82843V18C20 19.1046 19.1046 20 18 20Z" />
  </Icon>
);

export default SaveIcon;
